<template>
  <div class="apple__login">
    <button @click="handleAppleLogin">
      <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.70995 4.88461C9.56755 4.88461 10.6426 4.30483 11.2827 3.53179C11.8625 2.83121 12.2853 1.85283 12.2853 0.874444C12.2853 0.741577 12.2732 0.608709 12.249 0.5C11.2948 0.536236 10.1473 1.14018 9.45884 1.94946C8.91529 2.56548 8.42006 3.53179 8.42006 4.52225C8.42006 4.6672 8.44422 4.81214 8.45629 4.86046C8.51669 4.87254 8.61332 4.88461 8.70995 4.88461ZM5.69024 19.5C6.86189 19.5 7.38128 18.7149 8.84282 18.7149C10.3285 18.7149 10.6546 19.4758 11.9592 19.4758C13.2395 19.4758 14.0971 18.2921 14.9064 17.1325C15.8123 15.8039 16.1867 14.4994 16.2109 14.439C16.1264 14.4148 13.6743 13.4123 13.6743 10.5979C13.6743 8.15798 15.607 7.0588 15.7157 6.97425C14.4353 5.13827 12.4906 5.08996 11.9592 5.08996C10.5218 5.08996 9.35013 5.95963 8.61332 5.95963C7.81612 5.95963 6.76526 5.13827 5.52114 5.13827C3.15369 5.13827 0.75 7.09504 0.75 10.7912C0.75 13.0861 1.64383 15.514 2.74301 17.0842C3.68516 18.4129 4.50652 19.5 5.69024 19.5Z"
          fill="currentColor"
        />
      </svg>
      使用 Apple ID 登录
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      signedIn: false,
    }
  },
  methods: {
    async handleAppleLogin() {
      const url = this.buildLoginUrl()
      this.$store.dispatch('appleLogin/setLoading', true)
      window.ipcRenderer.send('openNewWindow', url.href)
    },
    // 构建登录url
    buildLoginUrl() {
      const url = new URL('https://appleid.apple.com/auth/authorize')
      url.searchParams.append('response_type', 'code id_token')
      url.searchParams.append('response_mode', 'form_post')
      url.searchParams.append('client_id', 'com.flomoapp.m.web')
      url.searchParams.append('redirect_uri', 'https://flomoapp.com/apple_account/login_by_identity_token_web')
      url.searchParams.append('scope', 'name email')
      url.searchParams.append('state', 'state')
      url.searchParams.append('nonce', 'nonce')
      return url
    },
  },
}
</script>
<style scoped lang="scss">
.apple__login {
  margin-top: 30px;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 56px;
    border-radius: 6px;
    background: var(--loginWxBg);
    border: 1px solid var(--loginBtnBorder);
    font-size: 14px;
    font-weight: 500;
    outline: none;
    cursor: pointer;
    color: var(--textBlack);
    svg {
      margin-right: 10px;
    }
    &:hover {
      background: var(--hoverBg);
    }
  }
}
</style>
